import { useCallback, useMemo } from 'react';
import { emitAck } from '../adminEmit';

export function useAdminUsersApi(socket) {
  const listUsers = useCallback(
    (params) => emitAck(socket, 'admin:users:list', params),
    [socket]
  );
  const getUser = useCallback(
    (userId, params = {}) => emitAck(socket, 'admin:users:get', { userId, ...params }),
    [socket]
  );
  const createUser = useCallback(
    (data) => emitAck(socket, 'admin:users:create', data),
    [socket]
  );
  const updateUser = useCallback(
    (data) => emitAck(socket, 'admin:users:update', data),
    [socket]
  );
  const setPassword = useCallback(
    (data) => emitAck(socket, 'admin:users:set_password', data),
    [socket]
  );
  const deleteUser = useCallback(
    (data) => emitAck(socket, 'admin:users:delete', data),
    [socket]
  );
  const getSessions = useCallback(
    (userId, limit = 50) => emitAck(socket, 'admin:users:sessions', { userId, limit }),
    [socket]
  );

  return useMemo(
    () => ({
      listUsers,
      getUser,
      createUser,
      updateUser,
      setPassword,
      deleteUser,
      getSessions,
    }),
    [listUsers, getUser, createUser, updateUser, setPassword, deleteUser, getSessions]
  );
}
